import Attachments from "./attachments";

export default Attachments;